var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.icon)?_c('span',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),_c('span',{class:{
      'ml-1': !!_vm.icon,
      'font-weight-bold': _vm.highlighted,
    }},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }